import http from '@/assets/common/http';
// 报价首页拉取团餐/供应商客户数据
export function queryQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 报价详情界面拉取数据
export function queryDetailQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出指定供应商与指定(供应链/团餐)的报价产品列表
export function exportQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取供应链的供应商报价列表
export function querySupplyChainQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 4,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 指定供应商与指定供应链的报价产品列表 含报价
export function exportSupplyChainQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 5,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 指定供应商与指定供应链的报价产品列表
export function querySupplierChainDetailQuote(data) {
  const params = {
    SERVICE_ID: '10014',
    OTYPE: 6,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取团餐公司
export function getCompanyList(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取团餐公司名称
export function tcName() {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 获取供应商公司
export function getSupplierList(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 53,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/quote.js